module.exports = __webpack_public_path__ + "img/works_mixi_xflag_1.58b55f4c.png";